import { useEffect, useState } from "react";
import { perf, times } from "../lib/perf";
import { diagState } from "../lib/diag";

const ms = (a, b) => (times[a] && times[b] && times[b] >= times[a] ? `${Math.round(times[b] - times[a])} ms` : "–");

// ?debug=1: tap → response times and what the gallery decided (3D, light 3D or the painted 2D wall) and why, readable on the visitor's own phone
export function DebugTimer() {
  const [, set] = useState(0);
  useEffect(() => {
    const on = () => set((n) => n + 1);
    window.addEventListener("afae-times", on);
    window.addEventListener("afae-diag", on);
    return () => {
      window.removeEventListener("afae-times", on);
      window.removeEventListener("afae-diag", on);
    };
  }, []);
  const d = diagState;
  const ev = d.events.slice(-3).map((e) => `  ${(e.t / 1000).toFixed(1)}s ${e.reason} ${e.detail}`.slice(0, 64)).join("\n");
  const er = d.errors.slice(-2).map((e) => `  ${e}`.slice(0, 64)).join("\n");
  return (
    <pre data-testid="debug-timer" className="pointer-events-none fixed bottom-24 left-3 z-[96] max-w-[92vw] whitespace-pre-wrap rounded-lg bg-black/75 p-2 font-mono text-[11px] leading-snug text-[#FFF4DC]">
      {`journey start  ${ms("playTap", "arcShown")}\nnext → glide   ${ms("nextTap", "glideFirst")}\nnext → arrive  ${ms("nextTap", "glideEnd")}\n`}
      <span data-testid="debug-diag">{`view     ${d.view}\nreason   ${d.reason || "none"}\nrenderer ${d.renderer || "–"}\nctx lost ${d.lost}${ev ? `\nevents\n${ev}` : ""}${er ? `\nerrors\n${er}` : ""}\nfps      ${Math.round(perf.fps)}`}</span>
    </pre>
  );
}
